// extracted by mini-css-extract-plugin
export default {"sucursal":"sucursal_sucursal__d+V-1","switch":"sucursal_switch__uOQOj","slider":"sucursal_slider__CCfXj","estado":"sucursal_estado__toxHK"};